import RatingSystemImg from "@workspace/main/src/assets/images/Rating System.png";
import InteractWithAIImg from "@workspace/main/src/assets/images/Interact With AI.png";
import ChatWithAI from "@workspace/main/src/assets/images/Chat With AI.png";

export const ASSESSMENT_TYPE = [
  {
    title: "Rating System",
    description:
      "This is an assignment where you need to ans questions and provide ex., just like in old-school formats.",
    iconImg: RatingSystemImg,
  },
  {
    title: "Interact with AI",
    description:
      "You can interact with Live Pulse AI—it's a fun, engaging way to connect and have interactive conversations!",
    iconImg: InteractWithAIImg,
  },
  {
    title: "Chat with AI",
    description:
      "It’s like a chat interaction where you answer questions in a conversational style.",
    iconImg: ChatWithAI,
  },
];
